import { render, staticRenderFns } from "./OsSelectCampaignDialog.vue?vue&type=template&id=6fe4ce9e&scoped=true"
import script from "./OsSelectCampaignDialog.vue?vue&type=script&lang=ts"
export * from "./OsSelectCampaignDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe4ce9e",
  null
  
)

export default component.exports